import { getStoreId } from "$/hooks/use-store-information"
import customBookingSectionQueries from "$/lib/queries/custom-booking-section-queries"
import servicePackageQueries from "$/lib/queries/service-package-queries"
import storeQueries from "$/lib/queries/store-queries"
import supportedBikeTypeQueries from "$/lib/queries/supported-bike-types-queries"
import washQueries from "$/lib/queries/wash-queries"
import { QueryClient } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"
import { z } from "zod"

const searchSchema = z.object({
  handInDate: z.string().optional(),
})

function prefetch(queryClient: QueryClient, storeId: string) {
  void queryClient.prefetchQuery(servicePackageQueries.list({ storeId }))
  void queryClient.prefetchQuery(storeQueries.detail(storeId))
  void queryClient.prefetchQuery(washQueries.list({ storeId }))
  void queryClient.prefetchQuery(supportedBikeTypeQueries.list(storeId))
  void queryClient.prefetchQuery(customBookingSectionQueries.list({ storeId }))
}

export const Route = createFileRoute("/(app)/_auth/jobs/book")({
  validateSearch: zodValidator(searchSchema),
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()

    if (storeId) prefetch(queryClient, storeId)

    return { crumb: "alfred.jobs.book.crumb" }
  },
})
